module.exports = __webpack_public_path__ + "img/close-black.9c561992.svg";